// Utility to standardize handling of sources vs example products
// Based on presence of `source_references_without_alibaba` we:
// - Show that list under label "Sources"
// - Move the original `source_references` to an "Example Products" section
// Otherwise, we keep `source_references` under label "Source References"

interface SourcesAndExamples {
  sourcesVal: any[];
  sourcesLabel: string;
  exampleProductsLabel: string | null;
  exampleProductsValues: any;
}

export function getSourcesAndExamples(nodeType: string, properties: Record<string, any>): SourcesAndExamples {
  const p = properties || {};
  const isTech = nodeType === 'TechnologyType' || nodeType === 'NoProductTechnologyType';
  if (isTech) {
    return {
      // Sources for tech types come from the "without_alibaba" list if present; otherwise no sources
      sourcesVal: Array.isArray(p.source_references_without_alibaba) ? p.source_references_without_alibaba : [],
      sourcesLabel: 'Sources',
      // Examples for tech types always come from source_references (if present)
      exampleProductsLabel: 'Example Products',
      exampleProductsValues: p.source_references,
    };
  }
  return {
    sourcesVal: p.source_references,
    sourcesLabel: 'Source References',
    exampleProductsLabel: null,
    exampleProductsValues: null,
  };
}


